import { render, staticRenderFns } from "./TokoIcon.vue?vue&type=template&id=e7379344"
import script from "./TokoIcon.vue?vue&type=script&lang=js"
export * from "./TokoIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports